import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/search.svg';
import { ReactComponent as IconSvg2 } from '@/images/icons/waimao/global_search_icon.svg';
import { ReactComponent as IconSvg3 } from '@/images/icons/waimao/search-icon-at-input.svg';
import { ReactComponent as IconSvg4 } from '@/images/icons/waimao/search-icon-at-input-hover.svg';
export const SearchIconAtInput = ({ hover }) => (!hover ? React.createElement(IconSvg3, null) : React.createElement(IconSvg4, null));
const SearchIcon = (props) => React.createElement(IconSvg, Object.assign({}, props));
export const SearchGlobalIcon = () => React.createElement(IconSvg2, null);
export default SearchIcon;
